// @flow
import React from 'react'

class MockLifebar extends React.Component {

  props: {
    hp: number,
    maxHp: number,
    isEnemyTeam: boolean
  };

  getFillPercent() {
    const {hp, maxHp} = this.props;

    //Floor at 0
    if (hp <= 0) {
      return "0%"
    }

    //Otherwise, figure out the fill percent
    return `${Math.round(hp/maxHp * 100)}%`;
  }

  getBackgroundFillColor() {

    if (this.props.hp <= 0) {
      return "#EFECEC" //dead gray
    }

    return this.props.isEnemyTeam ? "#F9DBDB" : "#DBE9F9"; //faded red, faded blue
  }

  render() {
    const {isEnemyTeam} = this.props;



    const barContainerStyle = {
      width: "100%",
      height: "0.5em",
      background: this.getBackgroundFillColor(),
      position: "relative"
    };
    const fillStyle = {
      position: "absolute",
      left: 0,
      top:0,
      bottom:0,
      background: isEnemyTeam ? "#E40924" : "#4A90E2", //foreground
      borderBottom: `0.2em solid ${ isEnemyTeam ? "#C41127" : "#246BBE" }`,
      width: this.getFillPercent(),
      //transition: "width 0.4s" //? keep this? or run with the easing function like in b4?
    };
    return (
      <div>
        <div style={barContainerStyle}>
          <div style={fillStyle} />
        </div>
      </div>
    );
  }
}



export default MockLifebar;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/Lifebar.js